import React, { Component } from "react";
import styled from "styled-components";
import { connect } from 'react-redux'
import { FastField } from 'formik'
import { isEmpty } from 'lodash'
// Components
import Table from "../../../components/Table";
import Container from "../../../containers/Container";
import { Row, Col, Modal, Icon, Tooltip, Popconfirm } from "antd";
import Button from "../../../components/Buttons";
import message from "../../../components/Messages";
import Message from "../../../components/Messages";
// typo
import typo, { MESSAGE } from "../../../constants/dictionaries";

import columns from "./VTQT.column";
import InfoTramQT from "../../../components/License/BieuDo/mauQTModalMT"
import TramQTModal from "./Modal"
import Api_tnn from "../../../api/api.tnn";
import QT_TramQT from "../../../models/QuanTrac_TNN/QT_TramQT";
import MapModal from '../../../components/BanDo/MiniMap/moitruong';
import DanhGiaModal from "../../BaoCaoDinhKy/FormKetQuaQuanTrac/DanhGia/QuanTrac"
class TramQT_TNN extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: [],
            mode: "add",
            pagination: {
                PageNumber: 1,
                PageSize: 10,
                Total: 0
            },
            selectedRow: null,
            isShowEditModal: false,
            isShowAddModal: false,
            isShowMapModal: false,
            isShowDanhGiaModal: false,
            LoaiTram_QT: undefined,
            selectedItemId: undefined,
            pickAll: {},
            selectedRowKeys: []
        };
    }

    componentDidMount() {
        const { idGiayPhep } = this.props;
        const { pagination } = this.state
        idGiayPhep && this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
    }
    getGiayPhepCTById = (page, size) => {
        const { idGiayPhep, apiGetTram_by_QD } = this.props;
        apiGetTram_by_QD({ token: this.props.user.access_token, idThongTinChung: idGiayPhep, page: page, size: size })
            .then(res => {
                this.setState({
                    data: res && res.data.map((vl, index) => ({ ...new QT_TramQT(vl), stt: index + 1, key: index + 1 })),
                    pagination: {
                        PageNumber: res && res.pagination && res.pagination.currentPage,
                        PageSize: size,
                        Total: res && res.pagination && res.pagination.total
                    },

                })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { pagination } = this.state
        if (prevProps.idGiayPhep !== this.props.idGiayPhep) {
            this.getGiayPhepCTById(1, 10)
        }
    }
    GetApiQT_TramQuanTrac = (id) => {
        const { apiGetBVMT_Tram } = this.props
        apiGetBVMT_Tram({
            token: this.props.user.access_token,
            id: id,
        })
            .then((res) => {
                this.setState({
                    isShowEditModal: true,
                    selectedItemId: undefined,
                    selectedRow: new QT_TramQT(res),
                });
            }).catch(err => {
                message.error(err.message)
            });
    };

    DeleteApiQT_TramQuanTrac = (id) => {
        const { pagination } = this.state
        const { apiDelete_Tram } = this.props
        apiDelete_Tram({
            token: this.props.user.access_token,
            id: id,
        })
            .then(res => {
                this.setState({
                    selectedItemId: undefined,
                    pickAll: {}
                });
                message.success(MESSAGE.CSCORE_REMOVE_SUCCESS)
                this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
            }).catch(err => {
                message.error(err.message)
            });
    };
    expandedRow = (record, index, indent, expanded) => {
        const { user, editable,
            apiGetTPMT_Exist,
            apiGetMauQT_by_Tram, phanloai,
            apiSoLan_VuotNguong,
            apiThongSo_Exist,
            apiGiaTriTimeLine
        } = this.props
        let data_modal_mau = {
            idGiayPhep: record.thongTinChung_Id,
            idTramQT: record.id
        }
        return <InfoTramQT
            user={user}
            phanloai={phanloai}
            data_modal_mau={data_modal_mau}
            editable={editable}
            apiGetTPMT_Exist={apiGetTPMT_Exist}
            apiGetMauQT_by_Tram={apiGetMauQT_by_Tram}
            apiSoLan_VuotNguong={apiSoLan_VuotNguong}
            apiThongSo_Exist={apiThongSo_Exist}
            apiGiaTriTimeLine={apiGiaTriTimeLine}
        />
    }
    showEditModal = (selectedRow, name) => {
        this.setState({ mode: name })
        this.GetApiQT_TramQuanTrac(selectedRow.id)
    };
    showAddModal = () => {
        this.setState({
            isShowAddModal: true,
            selectedItemId: undefined,
        });
    };
    showMapModal = async (selectedRow) => {
        const { apiGetBVMT_Tram, user, showmap, handleMap } = this.props;
        try {
            const response = await apiGetBVMT_Tram({ token: user.access_token, id: selectedRow.id })
            if (response && response.toaDo && response.toaDo !== "0,0") {
                if (showmap === "showmap") {
                    handleMap(selectedRow)
                }
                else {
                    this.setState({
                        isShowMapModal: true,
                        selectedRow
                    });
                }

            } else {
                Message.warning("Không có tọa độ")
            }
        } catch (error) {
            Message.error(error.message)
        }
    }
    handleAdd = () => {
        const { pagination } = this.state
        this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
        this.handleCancel();
    };
    showDanhGia = (selectedRow) => {
        this.setState({
            isShowDanhGiaModal: true,
            selectedRow
        });
    }

    handleCancel = () => {
        this.setState({
            isShowEditModal: false,
            isShowAddModal: false,
            isShowMapModal: false,
            isShowDanhGiaModal: false
        });
    };

    showDeleteConfirm = (selectedRow) => {
        this.setState({
            selectedRow
        });
        this.DeleteApiQT_TramQuanTrac(selectedRow)
    }
    /**
     * @function handleTableParamsChange Handle table params
     */
    handleTableParamsChange = (pagination, filteredInfo, sortedInfo) => {
        this.getGiayPhepCTById(pagination.current, pagination.pageSize)
    };
    deletaAll = () => {
        const { pickAll } = this.state
        if (pickAll && pickAll.length > 0) {
            pickAll.map((value, index) => {
                this.DeleteApiQT_TramQuanTrac(value.id)
            })
        this.setState({selectedRowKeys: []})
        }
    }


    render() {
        const {
            sortedInfo,
            selectedRow,
            isShowEditModal,
            isShowAddModal,
            isShowMapModal,
            isShowDanhGiaModal,
            pagination,
            data,
            selectedItemId,
            mode,
            pickAll,
            selectedRowKeys
        } = this.state;
        const { user, data_giayphep, editable, phanloai, apiGetDanhGia_Excel,
            apiGetTPMT_Exist, apiThongSo_Exist, apiGetBCDK_KQQT_By_ThongSo, apiGetBCDK_KQQT
        } = this.props;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({ selectedRowKeys: selectedRowKeys, pickAll: selectedRows })
            },
        };
        return (
            <div>
                <Container>
                    {editable &&
                        <Row type='flex' justify='space-between' style={{ marginBottom: 10 }}>
                            <div>
                                {pickAll && pickAll.length > 0 &&
                                    <Tooltip title="Xóa các vị trí quan trắc đã được chọn" placement="bottom">
                                        <Popconfirm placement="top" title="Bạn chắc chắn muốn xóa tất cả các vị trí quan trắc đã chọn"
                                            onConfirm={() => this.deletaAll()}
                                            onCancel={() => undefined}
                                            okText="Chắc chắn" cancelText="Không">
                                            <Button type="primary">
                                                <Icon type="delete" />Xóa tất cả
                                            </Button>
                                        </Popconfirm>
                                    </Tooltip>}</div>
                            <Tooltip title="Thêm mới" placement="top">
                                <Button type="primary" onClick={this.showAddModal}>
                                    <Icon type="plus" />
                                </Button>
                            </Tooltip>
                        </Row>}
                    {data.length > 0 ?
                        <Table
                            columns={columns({
                                sortedInfo,
                                showEditModal: this.showEditModal,
                                deleteRow: this.showDeleteConfirm,
                                showMapModal: this.showMapModal,
                                showViewModal: this.showEditModal,
                                showDanhGia: this.showDanhGia,
                                editable
                            })}
                            selectedRowId={selectedItemId}
                            onRowClick={(record) => this.setState({ selectedItemId: record.id })}
                            dataSource={data}
                            hideTotal="true"
                            onChange={this.handleTableParamsChange}
                            pagination={{
                                total: pagination.Total,
                                pageSize: pagination.PageSize,
                                current: pagination.PageNumber
                            }}
                            expandedRowRender={this.expandedRow}
                            rowSelection={rowSelection}
                        /> : <div style={{ color: "#cfcdcd", textAlign: "center" }}>Không có vị trí quan trắc</div>}
                    {isShowEditModal &&
                        <Modal
                            title={mode === "view" ? typo.cscore_thong_tin_chi_tiet : typo.cscore_edit_tramQT}
                            centered
                            closable={true}
                            visible={isShowEditModal}
                            width="900px"
                            footer={null}
                            onCancel={this.handleCancel}
                            maskClosable={false}
                        >
                            <TramQTModal
                                handleAdd={this.handleAdd}
                                handleCloseModal={this.handleCancel}
                                defaultData={data}
                                selectedRow={selectedRow}
                                isEdit={true}
                                user={user}
                                mode={mode}
                                phanloai={phanloai}
                            />
                        </Modal>
                    }
                    {isShowAddModal &&
                        <Modal
                            title={typo.cscore_add_tramQT}
                            centered
                            closable={true}
                            visible={isShowAddModal}
                            width="900px"
                            footer={null}
                            onCancel={this.handleCancel}
                            maskClosable={false}
                        >
                            <TramQTModal
                                handleAdd={this.handleAdd}
                                handleCloseModal={this.handleCancel}
                                user={user}
                                selectedRow={data_giayphep}
                                phanloai={phanloai}
                            />
                        </Modal>
                    }
                    {isShowMapModal &&
                        <Modal
                            centered
                            closable={true}
                            visible={isShowMapModal}
                            width="60%"
                            footer={null}
                            onCancel={this.handleCancel}
                        >
                            <MapModal
                                dulieu={{...selectedRow, idtramquantrac: selectedRow.id}}
                                user={user}
                                loai={phanloai}
                            />
                        </Modal>
                    }
                    {isShowDanhGiaModal &&
                        <Modal
                            title="Đánh giá kết quả quan trắc"
                            centered
                            closable={true}
                            visible={isShowDanhGiaModal}
                            width="80%"
                            footer={null}
                            onCancel={this.handleCancel}
                            maskClosable={false}
                        >
                            <DanhGiaModal
                                handleCloseModal={this.handleCancel}
                                selectedRow={selectedRow}
                                user={user}
                                GetTPMT_Exist={apiGetTPMT_Exist}
                                GetThongSos_Exist={apiThongSo_Exist}
                                GetBCDK_KQQT_By_ThongSo={apiGetBCDK_KQQT_By_ThongSo}
                                GetBCDK_KQQT_QD={apiGetBCDK_KQQT}
                                GetDanhGia_Excel={apiGetDanhGia_Excel}
                            />
                        </Modal>
                    }
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});

export default connect(mapStateToProps)(TramQT_TNN);
